export default{
    //Apiserveraddress:"https://elearning.waheguruitsol.co.in/",
    WebServerAddress:"https://learnisl.com",
    Apiserveraddress:"https://learnisl.com/api/",
    VideoPath:"https://learnisl.com/isldata/",
    localAddress:"http://localhost:3000/",
    
};